import { render } from "./BtnRequestQuotation.vue?vue&type=template&id=522fd70c&scoped=true"
import script from "./BtnRequestQuotation.vue?vue&type=script&lang=js"
export * from "./BtnRequestQuotation.vue?vue&type=script&lang=js"

import "./BtnRequestQuotation.vue?vue&type=style&index=0&id=522fd70c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522fd70c"]])

export default __exports__